import useFeatures from 'hooks/useFeatures';
import useExperiment from 'hooks/useExperiment';
import { FormattedMessage } from '@alltrails/shared/react-intl';

export default function usePlusFeatures() {
  const flipperFeatures = useFeatures();
  const areGarminCoursesEnabled = flipperFeatures.includes('garmin_courses');
  const rttcv2 = useExperiment('web-trails-trail-conditions-v2')?.value === 'rttc-v2';
  return [
    { pro: false, text: <FormattedMessage defaultMessage="Navigate on the trail" /> },
    { pro: false, text: <FormattedMessage defaultMessage="Favorite trails and create lists" /> },
    ...(areGarminCoursesEnabled ? [{ new: true, pro: true, text: <FormattedMessage defaultMessage="Send routes to Garmin" /> }] : []),
    { pro: true, text: <FormattedMessage defaultMessage="Download offline maps" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Get alerts for wrong turns" /> },
    ...(rttcv2 ? [{ new: true, pro: true, text: <FormattedMessage defaultMessage="Know conditions before you go" /> }] : []),
    { new: true, pro: true, text: <FormattedMessage defaultMessage="Preview 3D Flyovers" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Find trails by distance from you" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Unlock more map details" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Print maps for backup" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Bring trails to life with 3D maps" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Explore ad free" /> },
    { pro: true, text: <FormattedMessage defaultMessage="Give back with 1% for the Planet" /> }
  ];
}
